function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("title", null, "send-email-2"), React.createElement("path", {
  d: "M8.014,24.003c-0.27,0-0.525-0.105-0.716-0.296c-0.189-0.189-0.297-0.451-0.297-0.718v-4.921l-6.273-3.873 c-0.713-0.433-0.941-1.368-0.507-2.082c0.149-0.245,0.363-0.442,0.618-0.57L23.273,0.058c0.012-0.006,0.026-0.012,0.04-0.016 c0.008-0.003,0.017-0.006,0.022-0.008c0.032-0.012,0.076-0.023,0.12-0.027c0.008-0.001,0.038-0.002,0.046-0.002 c0.053,0,0.1,0.008,0.145,0.022c0.013,0.002,0.016,0.004,0.028,0.008c0.052,0.02,0.097,0.045,0.136,0.076 c0.004,0.004,0.025,0.021,0.031,0.026c0.016,0.014,0.028,0.029,0.036,0.041c0.024,0.028,0.045,0.059,0.062,0.092 c0.004,0.008,0.019,0.038,0.022,0.046C23.985,0.37,23.997,0.425,24,0.479c0,0.01,0,0.021,0,0.032c0,0.037-0.004,0.075-0.013,0.111 L18.56,22.835c-0.12,0.481-0.466,0.876-0.926,1.058c-0.182,0.073-0.376,0.11-0.576,0.11c-0.291,0-0.574-0.08-0.821-0.231 l-4.682-2.89L8.73,23.706C8.539,23.898,8.285,24.003,8.014,24.003L8.014,24.003z M16.762,22.92c0.088,0.054,0.19,0.083,0.295,0.083 c0.072,0,0.142-0.013,0.208-0.04c0.162-0.063,0.282-0.201,0.323-0.367l4.969-20.337L8.281,17.683L16.762,22.92z M8.001,22.99 l2.68-2.65l-2.68-1.654V22.99z M7.413,17.148L21.218,2.234L1.29,12.436c-0.091,0.045-0.164,0.113-0.215,0.197 c-0.071,0.118-0.093,0.256-0.06,0.391c0.033,0.134,0.116,0.248,0.234,0.319c0.001,0,0.003,0.002,0.003,0.002L7.413,17.148z ",
  fill: "#9B9B9B"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    id: "Layer_1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      "enableBackground": "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/mail-line.433b1eb2.svg";
export { SvgComponent as ReactComponent };